module.exports = __webpack_public_path__ + "static/img/backg11.f38585ae.png";